import React, { useEffect, useState } from 'react';
import azureDevOpsService from './services/azureDevOpsService';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function KpiBugsResolutionRateBySquad() {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const bugs = await azureDevOpsService.getBugsWithTA();
      
      // Grouper les bugs par squad
      const bugsBySquad = {};
      bugs.forEach(bug => {
        const areaPath = bug.areaPath || '';
        let squad;
        
        // Vérifier si le bug fait partie d'un squad
        if (areaPath.startsWith('Fabrique\\Tribus\\Tribu Argonos\\Squads\\')) {
          squad = areaPath.replace('Fabrique\\Tribus\\Tribu Argonos\\Squads\\', '');
          // Regrouper les squads "Etendu" avec leur squad parent
          squad = squad.replace(/\\Etendu$/, '');
        } else {
          // Tous les bugs hors squads vont dans "Autres"
          squad = 'Autres';
        }
        
        if (!bugsBySquad[squad]) {
          bugsBySquad[squad] = {
            total: 0,
            resolved: 0,
          };
        }
        bugsBySquad[squad].total++;
        
        // Vérifier si le bug est résolu
        const state = bug.state;
        if (state === '6- Done' || state === '6- Cancelled' || state === '5- Validation') {
          bugsBySquad[squad].resolved++;
        }
      });
      
      // Trier les squads par ordre alphabétique, avec 'Autres' à la fin
      const sortedSquads = Object.keys(bugsBySquad).sort((a, b) => {
        if (a === 'Autres') return 1;
        if (b === 'Autres') return -1;
        return a.localeCompare(b);
      });
      
      // Calculer les taux de résolution
      const resolutionRates = sortedSquads.map(squad => {
        const data = bugsBySquad[squad];
        return data.total > 0 ? ((data.resolved / data.total) * 100).toFixed(1) : 0;
      });
      
      const unresolvedCounts = sortedSquads.map(squad => {
        const data = bugsBySquad[squad];
        return data.total - data.resolved;
      });
      
      const resolvedCounts = sortedSquads.map(squad => bugsBySquad[squad].resolved);
      
      setChartData({
        labels: sortedSquads,
        datasets: [
          {
            label: 'Résolus',
            data: resolvedCounts,
            backgroundColor: 'rgba(34, 197, 94, 0.7)',
            stack: 'bugs',
          },
          {
            label: 'Non résolus',
            data: unresolvedCounts,
            backgroundColor: 'rgba(239, 68, 68, 0.7)',
            stack: 'bugs',
          },
        ],
      });
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <div className="bg-white rounded shadow p-6">
      <h2 className="text-lg font-bold mb-4">Taux de résolution des bugs TA par squad</h2>
      {loading || !chartData ? (
        <div>Chargement...</div>
      ) : (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: { position: 'top' },
              title: {
                display: true,
                text: 'Bugs TA résolus vs non résolus par squad',
              },
              tooltip: {
                callbacks: {
                  afterTitle: function(context) {
                    const dataIndex = context[0].dataIndex;
                    const resolved = chartData.datasets[0].data[dataIndex];
                    const unresolved = chartData.datasets[1].data[dataIndex];
                    const total = resolved + unresolved;
                    const rate = total > 0 ? ((resolved / total) * 100).toFixed(1) : 0;
                    return `Taux de résolution: ${rate}%`;
                  }
                }
              }
            },
            scales: {
              x: { 
                stacked: true, 
                title: { display: true, text: 'Squad' },
                ticks: { autoSkip: false, maxRotation: 45, minRotation: 45 }
              },
              y: { 
                stacked: true, 
                title: { display: true, text: 'Nombre de bugs' }, 
                beginAtZero: true 
              },
            },
          }}
        />
      )}
    </div>
  );
}
